import React, { Component } from 'react';

export default class DateSelector extends Component {

  constructor(props){
    super(props);
    var today = new Date();
    this.state = this.makeState(today.getFullYear(), today.getMonth(), today.getDate());
    this.triggerChange();
  }

  handleYearChange = (e) => {
    var v = parseInt(e.target.value, 10);
    this.setState(this.makeState(v, this.state.month, this.state.day), this.triggerChange);
  }

  handleMonthChange = (e) => {
    var v = parseInt(e.target.value, 10);
    this.setState(this.makeState(this.state.year, v, this.state.day), this.triggerChange);
  }

  handleDayChange = (e) => {
    var v = parseInt(e.target.value, 10);
    this.setState(this.makeState(this.state.year, this.state.month, v), this.triggerChange);
  }

  triggerChange() {
    this.props.onChange({target: this});
  }

  makeState(year, month, day) {

    var s = {};

    s.year = year;
    s.month = month;
    s.day = day;

    return s;
  }
  
  daysInMonth (month, year) {
    var d = new Date(year, month + 1, 0).getDate();
    return d;
  }

  render() {

    var years = [];
    for (var i = 0; i < 100; i++) {
      years.push(<option key={i}>{new Date().getFullYear() - i}</option>);
    }

    var months = [];
    var monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    for (i = 0; i < monthNames.length; i++) {
      months.push(<option key={i} value={i}>{monthNames[i]}</option>);
    }

    var days = [];
    var num = this.daysInMonth(this.state.month, this.state.year);
    for (i = 0; i < num; i++) {
      days.push(<option key={i}>{i + 1}</option>);
    }

    return (
      <div className="pad20">
        <div className="row">
          <div className="col-md-12">
            <label>Date:</label>
            <select onChange={this.handleYearChange} value={this.state.year}>{years}</select>
            <select className="ml10" onChange={this.handleMonthChange} value={this.state.month}>{months}</select>
            <select className="ml10" onChange={this.handleDayChange} value={this.state.day}>{days}</select>
          </div>
        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/DateSelector.js